import React from "react"
import theme from "../../trekronorTheme"
export default function StepBodyBg({children}){
    return (
        <div style={{backgroundColor:theme.colors.primary5}}>
            {children}
        </div>
    )
}